// extracted by mini-css-extract-plugin
export default {"form":"_3v_WxBN8Nk9qQbcF6IpE_D","buttons":"_1dVKfUeeEg06NRRkqX-pGt"};